/* eslint eqeqeq: 0 */
import * as constants from "../../constants/teaserList";

export default function (state = constants.STATUS_ACTIVE, action) {
  if (action.type == constants.SET_STATUS_FILTER) {
    return action.status;
  }
  return state;
}
